<template>
  <span class="app-sharebar" aria-hidden="true">
    <span class="app-sharebar__track" :style="trackStyle">
      <span v-for="(seg, i) in segments" :key="i" class="app-sharebar__seg" :style="seg"></span>
    </span>
  </span>
</template>

<script>
// Anteilsbalken (Spezifikation 2.10, gen_r3.py:545–553): 6 px hoch, Radius 2, Spur #e1e6ec für den Rest,
// unten bündig im Grafikfeld. parts: [{ value, color }] mit Token-Namen als Farbe ('d-std', 'st-late' oder
// '--d-std'); total: Gesamtwert; gap: Fuge zwischen den Teilen (0; „Busse unterwegs“ 2). Rein dekorativ.
function colorOf(c) {
  if (!c) {
    return 'var(--d-std)';
  }
  if (/^(var\(|#|rgb|hsl)/.test(c)) {
    return c;
  }
  return c.indexOf('--') === 0 ? 'var(' + c + ')' : 'var(--' + c + ')';
}

export default {
  name: 'AppShareBar',
  props: {
    parts: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    gap: { type: [Number, String], default: 0 }
  },
  computed: {
    trackStyle() {
      return { gap: (Number(this.gap) || 0) + 'px' };
    },
    segments() {
      const segs = [];
      let filled = 0;
      this.parts.forEach((part) => {
        const n = Number(part && part.value) || 0;
        if (n > 0) {
          filled += n;
          segs.push({ flex: n + ' 1 0px', background: colorOf(part.color) });
        }
      });
      const rest = (Number(this.total) || 0) - filled;
      if (rest > 0 || !segs.length) {
        segs.push({ flex: (rest > 0 ? rest : 1) + ' 1 0px', background: 'var(--d-trk)' });
      }
      return segs;
    }
  }
};
</script>
